import { FleekError } from './FleekError';

type FleekFunctionInvalidWasmCodeErrorOptions = Record<string, never>;

export class FleekFunctionInvalidWasmCodeError extends FleekError<FleekFunctionInvalidWasmCodeErrorOptions> {
  public name = 'FleekFunctionInvalidWasmCodeError';

  toString = () => {
    return `Fleek function encountered corrupt or invalid WASM code.`;
  };
}
